import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-bg-primary py-10" data-id="element-79" data-mp="2082j57csaif4">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center sm:px-6" data-id="element-80" data-mp="209x4unvvqek9">
        <p className="font-heading text-lg font-semibold uppercase tracking-wide text-white" data-id="element-81" data-mp="2f2h61izgybz2">
          ⚽ Manuales Listos
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted" data-id="element-82" data-mp="1mfcxj4163fij">
          <a href="https://www.manualeslistos.com" className="flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-83" data-mp="1hhunfabeyu8y">
            <GlobeIcon size={14} data-id="element-84" data-mp="1w7sbzrd99lyo" />
            www.manualeslistos.com
          </a>
          <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 transition-colors hover:text-lime" data-id="element-85" data-mp="1rd60zpb35vf4">
            <MailIcon size={14} data-id="element-86" data-mp="ypin0t4bm31g" />
            manualeslistos@gmail.com
          </a>
        </div>
        <p className="text-xs text-muted/70" data-id="element-87" data-mp="1eh0z56k4f8z2">
          © Manuales Listos {new Date().getFullYear()} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}